<template>
  <button class="drill-down" @click="setDrillDown(!isDrillDownOpen)">
    <span class="drill-down__label">{{ label }}</span>
    <svgicon
      :name="isDrillDownOpen ? 'menu-close' : 'arrow-down'"
      width="1.875rem"
      height="1.875rem"
      color="var(--scala-grigi-gray-1)"
      :class="['drill-down__icon', { 'icon-close': isDrillDownOpen }]"
    />
  </button>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DrillDownButton",
  props: {
    label: { type: String, default: "Oil-production Quality" },
  },
  data() {
    return {
      config: {},
    };
  },
  computed: {
    ...mapGetters({
      isDrillDownOpen: "ui/isDrillDownOpen",
    }),
  },
  methods: {
    ...mapActions({
      setDrillDown: "ui/toggleDrillDown",
    }),
  },
};
</script>

<style lang="scss" scoped>
$heightButton: calc(calc(100vh - toRem(50)) * -1);
.drill-down {
  width: toRem(319);
  height: $button-drill-height;
  margin: auto;
  background-color: var(--primary-yellow);
  border-radius: 20px 20px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  @include link-L;

  &__label {
    transition: opacity 0.3s linear;
    opacity: 0.8;
  }

  &__icon {
    animation-name: arrow-bounce;
    animation-duration: 0.7s;
    animation-iteration-count: infinite;
    animation-direction: alternate-reverse;
    transform: translateY(-2.5px);
    color: var(--scala-grigi-gray-1);

    &.icon-close {
      animation-name: none;
      transform: translateY(0px);
    }
  }

  &:hover {
    .drill-down__label {
      opacity: 1;
    }
  }
}

@keyframes arrow-bounce {
  0% {
    transform: translateY(-2.5px);
  }
  100% {
    transform: translateY(2.5px);
  }
}
</style>
